import { WEBSITE_ORDER_CHANNEL } from "@/constants/orderChannel"
import { getRestaurantId } from "@/config/restaurant-id"

/**
 * Cache key still includes bootstrap RestaurantId for tenant segmentation.
 * HTTP discounts fetch uses public/v1/storefront/r/{slug}/discounts (no RestaurantId on the wire).
 */
export function discountsByRestaurantQueryKey(
  restaurantId: string = getRestaurantId()
): string {
  return `discounts|by-restaurant|${restaurantId.trim()}|${WEBSITE_ORDER_CHANNEL}`
}
